<template>
  <div id="contenedor-editar-estimacion">
    <v-row>
      <text-field
        v-model.number="estimacion.numero"
        label="Número"
        type="number"
        readonly
        cols="12"
        md="1">
      </text-field>
      <date-picker
        v-model="estimacion.fechaDel"
        label="Fecha Del"
        cols="6"
        md="2">
      </date-picker>
      <date-picker
        v-model="estimacion.fechaAl"
        label="Fecha Al"
        cols="6"
        md="2"
        :max="fechaFinPrograma">
      </date-picker>
      <date-picker
        v-model="estimacion.fechaPresentacion"
        label="F. presentación"
        cols="6"
        md="2">
      </date-picker>
      <date-picker
        v-model="estimacion.fechaAutorizacion"
        label="F. autorización"
        cols="6"
        md="2">
      </date-picker>
      <v-spacer></v-spacer>
      <text-field
        v-model.number="estimacion.porcentajeAnticipo"
        type="number"
        label="% Anticipo"
        cols="6"
        md="1">
      </text-field>
      <text-field
        v-model.number="estimacion.porcentajeIva"
        type="number"
        label="% I.V.A"
        cols="6"
        md="1">
      </text-field>
      <text-field
        v-if="contrato.esObraFinanciada"
        v-model.number="estimacion.importeCostoFinanciero"
        label="Importe Costo F."
        es-dinero
        prefix="$"
        cols="6"
        md="2">
      </text-field>
      <v-col
        cols="12"
        md="auto">
        <v-tooltip
          top>
          <template
            v-slot:activator="{ on, attrs }">
            <v-badge
              content="+"
              :value="estimacion.observaciones.length > 0"
              color="green"
              overlap>
              <v-btn
                @click="mostrarAgregarObservacion = !mostrarAgregarObservacion"
                depressed
                fab
                v-bind="attrs"
                v-on="on">
                <v-icon>
                  mdi-comment-plus
                </v-icon>
              </v-btn>
            </v-badge>
          </template>
          <span>
            Agregar observaciones
          </span>
        </v-tooltip>
      </v-col>
      <v-spacer></v-spacer>
      <v-col
        cols="6" md="auto">
        <v-switch
          v-model="amortizarAnticipo"
          inset
          label="Amortizar Ant."
          hide-details>
        </v-switch>
      </v-col>
      <v-col
        cols="6" md="auto">
        <v-switch
          v-model="estimacion.esEstimacionFiniquito"
          inset
          label="Finiquito"
          hide-details>
        </v-switch>
      </v-col>
    </v-row>
    <v-alert
      v-show="!$apollo.queries.contratoDeducciones.loading && contratoDeducciones.length <= 0"
      type="warning">
      No se han podido cargar Deducciones.
    </v-alert>
    <v-row>
      <v-col cols="12" md="8">
        <v-card
          outlined>
          <v-toolbar flat>
            <v-toolbar-title>Catálogo de conceptos</v-toolbar-title>
            <v-row no-gutters class="ml-3">
              <v-col cols="auto">
                <v-text-field
                  v-model="filtros.buscarConcepto"
                  prepend-inner-icon="mdi-magnify"
                  filled
                  rounded
                  dense
                  hide-details
                  clearable
                ></v-text-field>
              </v-col>
              <v-spacer></v-spacer>
            </v-row>
            <div class="flex-row justify-center align-center" style="width: 200px"></div>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text class="altura-catalogo-conceptos pt-4">
            <catalogo-conceptos
              v-if="estimacionEditar"
              :filtros="filtros"
              :numero-estimacion="estimacion.numero"
              :conceptos-estimados-editar="estimacionEditar.conceptos"
              v-on:conceptosEstimados="conceptosEstimados"
              v-on:conceptosAEliminar="conceptosAEliminar"
            ></catalogo-conceptos>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-chip class="mr-2">
              Conceptos Est.
              {{ estimacion.conceptos.length || 0 }}
            </v-chip>
            <v-chip
              color="#74b782"
              dark>
              Total:
              {{ importeTotalEstimado | currency }}
            </v-chip>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card
          outlined>
          <v-card-title>Montos de la Estimación</v-card-title>
          <v-divider></v-divider>
          <v-list subheader>
            <template v-for="(calculo, index) in mostrarCalculos">
              <v-list-item v-if="calculo.titulo !== 'divisor'" :key="index" link>
                <v-list-item-avatar v-if="!$vuetify.breakpoint.mobile">
                  <v-icon v-if="calculo.signo !== ''">
                    <template v-if="calculo.signo === '+'">mdi-plus</template>
                    <template v-else>mdi-minus</template>
                  </v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title
                    class="font-weight-medium">
                    {{ calculo.titulo }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-chip
                    :color="colorPorSigno(calculo.signo)"
                    :dark="calculo.signo !== ''"
                    readonly
                  >{{ calculo.monto | currency }}</v-chip>
                </v-list-item-action>
              </v-list-item>
              <v-divider
                v-else
                class="my-1"
                :key="`divider-${index}`"
                :inset="!$vuetify.breakpoint.mobile"
              ></v-divider>
            </template>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog
      v-model="mostrarAgregarObservacion"
      width="500">
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text>
          <text-area
            v-model="estimacion.observaciones"
            label="Observaciones"
            placeholder="Desripción de la observacion">
          </text-area>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="mostrarAgregarObservacion = !mostrarAgregarObservacion"
            tipo="formAceptar"
            label="Aceptar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import mixAvanceFisico from '@/helpers/calculos/mixAvanceFisico';
import TextField from '@/components/inputs/TextField.vue';
import DatePicker from '@/components/inputs/DatePicker.vue';
import TextArea from '@/components/inputs/TextArea.vue';
import CustomButton from '@/components/buttons/Button.vue';
import CatalogoConceptos from './CatalogoConceptos.vue';
import mixEstimaciones from '../mixEstimaciones';
import mixCalcularAvanceProgramado from '../mixCalcularAvanceProgramado';
import mixCalcularDeducciones from '../mixCalcularDeducciones';
import mixCalcularSancion from '../mixCalcularSancion';
import mixCalcularFinanciamiento from '../mixCalcularFinanciamiento';
import mixCalcularAnticipoFinanciamiento from '../mixCalcularAnticipoFinanciamiento';
import mixCalcularRetencion from '../mixCalcularRetencion';

export default {
  name: 'EditarEstimacion',
  mixins: [
    mixEstimaciones,
    mixCalcularAvanceProgramado,
    mixCalcularDeducciones,
    mixCalcularSancion,
    mixCalcularFinanciamiento,
    mixCalcularAnticipoFinanciamiento,
    mixCalcularRetencion,
    mixAvanceFisico,
  ],
  props: {
    estimacionEditar: {
      type: Object,
      required: true,
    },
    contrato: {
      type: Object,
      required: true,
    },
    estimaciones: {
      type: Array,
      required: true,
    },
    programa: {
      type: Object,
      required: true,
    },
  },
  components: {
    CatalogoConceptos,
    TextField,
    DatePicker,
    TextArea,
    CustomButton,
  },
  data() {
    return {
      filtros: {
        buscarConcepto: '',
        soloEstimados: false,
        sinEstimar: false,
      },
      enviadoFormulario: false,
      amortizarAnticipo: false,
      porcentajeAmortizacionAnticipo: 30,
      fechaAl: '',
      periodicidadSancion: 'MENSUAL',
      mostrarAgregarObservacion: false,
      estimacion: {
        numero: this.estimacionEditar.numero,
        importeContratoConFinanciamiento: 0,
        importeContratoSinFinanciamiento: 0,
        fechaPresentacion: this.estimacionEditar.fechaPresentacion
        || new Date().toISOString().slice(0, 10),
        fechaDel: this.estimacionEditar.fechaDel,
        fechaAl: this.estimacionEditar.fechaAl,
        fechaInicioContrato: this.contrato.modificado.fechaInicio === null
          ? this.contrato.fechaInicio
          : this.contrato.modificado.fechaInicio,
        fechaTerminoContrato: this.contrato.modificado.fechaTermino === null
          ? this.contrato.fechaTermino
          : this.contrato.modificado.fechaTermino,
        porcentajeIva: this.contrato.porcentajeIva,
        importeCostoDirecto: this.estimacionEditar.importeCostoDirecto,
        importeCostoIndirectos: this.estimacionEditar.importeCostoIndirectos,
        importeUtilidad: this.estimacionEditar.importeUtilidad,
        importeCargosAdicionales: this.estimacionEditar.importeCargosAdicionales,
        porcentajeCostoFinanciero: this.estimacionEditar.porcentajeCostoFinanciero,
        importeCostoFinanciero: this.estimacionEditar.importeCostoFinanciero,
        importeEstimado: this.estimacionEditar.importeEstimado,
        importeRetenido: this.estimacionEditar.importeRetenido,
        importeDevuelto: this.estimacionEditar.importeDevuelto,
        importeNeto: this.estimacionEditar.importeNeto,
        porcentajeAnticipo: this.estimacionEditar.porcentajeAnticipo,
        importeAnticipo: this.estimacionEditar.importeAnticipo,
        importeAnticipoFinanciamiento: this.estimacionEditar.importeAnticipoFinanciamiento,
        importeAmortizacionAnticipo: this.estimacionEditar.importeAmortizacionAnticipo,
        importeCostoFinancieroAmortizacionAnticipo: this.estimacionEditar
          .importeCostoFinancieroAmortizacionAnticipo,
        importeCostoFinancieroEstimacion: this.estimacionEditar.importeCostoFinancieroEstimacion,
        subtotal: this.estimacionEditar.subtotal,
        subtotalDos: this.estimacionEditar.subtotalDos,
        importeIva: this.estimacionEditar.importeIva,
        totalFactura: this.estimacionEditar.totalFactura,
        importeBonificacion: this.estimacionEditar.importeBonificacion,
        importeMontoProgramado: this.estimacionEditar.importeMontoProgramado,
        importeMontoFueraPrograma: this.estimacionEditar.importeMontoFueraPrograma,
        importeDeducciones: this.estimacionEditar.importeDeducciones,
        importeSancion: this.estimacionEditar.importeSancion,
        importeLiquido: this.estimacionEditar.importeLiquido,
        porcentajeAvanceFinanciero: this.estimacionEditar.porcentajeAvanceFinanciero,
        porcentajeAvanceFisico: this.estimacionEditar.porcentajeAvanceFisico,
        bonificacionDetalle: '',
        esEstimacionFinPrograma: this.estimacionEditar.esEstimacionFinPrograma,
        esEstimacionFiniquito: this.estimacionEditar.esEstimacionFiniquito,
        fechaAutorizacion: this.estimacionEditar.fechaAutorizacion,
        observaciones: this.estimacionEditar.observaciones,
        conceptos: this.estimacionEditar.conceptos
          .map(({ idConcepto, cantidad, importe }) => ({
            idConcepto,
            cantidad,
            importe,
            estimado: true,
          })),
        conceptosAEliminar: [],
        deducciones: this.estimacionEditar.deducciones
          .map(({ importe, deduccion }) => ({
            idDeduccion: deduccion.id,
            importe,
          })),
        programa: [],
      },
    };
  },
  mounted() {
  },
  methods: {
    conceptosEstimados(conceptos) {
      this.estimacion.conceptos = conceptos;
      this.calcularEstimacion();
    },
    conceptosAEliminar(conceptos) {
      this.estimacion.conceptosAEliminar = conceptos;
    },
    calcularEstimacion() {
      const fechaAl = new Date(`${this.estimacion.fechaAl} 00:00:0`);
      const fechaProgramaFin = new Date(
        `${this.programa.programaFinal.fechaTermino} 00:00:0`,
      );

      // Validar que existan conceptos a estimar
      if (this.importeTotalEstimado === 0) return;

      // Igual el importe de costo directo al total estimado de esta estimacion
      this.estimacion.importeCostoDirecto = this.importeTotalEstimado;

      // Comprobar si es obra financiada
      if (this.contrato.esObraFinanciada) {
        // Hacer calculos de financiamiento
        this.mixCalcularFinanciamiento();
      }

      // Importe estimado
      this.estimacion.importeEstimado = this.mixImporteAntesCostoFinanciero;

      // Comprobar si se alcanzo el techo
      if (this.importeEstimadoActual === this.importeDelContrato) {
        // Si alcanzo el techo, marcar que estimacion finiquito
        this.estimacion.esEstimacionFiniquito = true;
      }

      // Comprobar si el importe estimado actual (estimaciones anteriores + actual)
      // no sea mayor al importe del contrato mas sus moficaciones
      if (this.importeEstimadoActual > this.importeDelContrato) {
        this.mixMensajeError(`El importe Estimado (${this.importeEstimadoActual}) es mayor al importe del Contrato + Convenios (${this.importeDelContrato}).`);
      }

      // set el importe programado para esta estiamcion a la fecha
      this.estimacion.importeMontoProgramado = this.importeProgramadoActual.importe;

      // Checar si esta dentro de programa
      if (fechaAl <= fechaProgramaFin) {
        // Calcular estimacion dentro de programa
        this.calcularEstimacionDentroPrograma();
      } else {
        // Si esta fuera de programa
        // Calcular la sancion
        this.calcularEstimacionFueraPrograma();
        // Hacer calculos
        this.calculos();
      }
    },
    calcularEstimacionDentroPrograma() {
      // poner la sancion en 0
      this.estimacion.importeSancion = 0;
      // Importe programado para esta estimacion
      const importeProgramado = this.estimacion.importeMontoProgramado;

      // Declarar las varibles de importe rentencion e importe devuelto = 0
      this.estimacion.importeDevuelto = 0;
      this.estimacion.importeRetenido = 0;

      // Cechecar si la estimacion va entro del programa
      if (this.importeEstimadoActual >= importeProgramado
      || this.estimacion.esEstimacionFiniquito) {
        // Calcular estimacion a tiempo
        this.calcularEstimacionAlCorriente();
      } else {
        // Calcular estimacion con atraso
        this.calcularEstimacionConAtraso();
      }
    },
    calcularEstimacionFueraPrograma() {
      this.mixCalcularSancion();
    },
    calcularEstimacionAlCorriente() {
      // Devolucion en caso de tener retenido
      this.estimacion.importeDevuelto = this.importeRetenidoAnterior - this.importeDevueltoAnterior;

      // Hacer calculos
      this.calculos();
    },
    calcularEstimacionConAtraso() {
      // Calcular retencion o devolucion
      this.mixCalcularRetencion();
      // Hacer calculos
      this.calculos();
    },
    calcularPorcentajeAvanceFisico() {
      const { esEstimacionFiniquito, fechaAl } = this.estimacion;

      if (esEstimacionFiniquito) {
        this.estimacion.porcentajeAvanceFisico = 100;
      } else {
        this.estimacion.porcentajeAvanceFisico = this.mixAvanceFisicoFecha(fechaAl);
      }
    },
    colorPorSigno(signo) {
      if (signo) {
        return signo === '+' ? 'success' : 'error';
      }
      return '';
    },
  },
  computed: {
    getUltimaEstimacion() {
      if (this.estimaciones.length <= 0) return {};
      return this.estimaciones.find(
        (estimacion) => Number(estimacion.numero) === this.estimaciones.length,
      );
    },
    importeContrato() {
      if (!this.contrato) return 0;
      const {
        importeCostoDirecto, importeCostoIndirectos, importeUtilidad, importeCargosAdicionales,
      } = this.contrato;
      if (this.contrato.esObraFinanciada) {
        return this.$numberRound((
          importeCostoDirecto + importeCostoIndirectos + importeUtilidad + importeCargosAdicionales
        ));
      }
      return this.contrato.importe;
    },
    importeDelContrato() {
      return this.importeContrato + this.importeContratoModificado;
    },
    importeContratoModificado() {
      if (this.contrato.esObraFinanciada) {
        return (
          this.contrato.modificado.importeCostoDirecto
          + this.contrato.modificado.importeCostoIndirectos
          + this.contrato.modificado.importeUtilidad
          + this.contrato.modificado.importeCargosAdicionales
        );
      }

      return this.contrato.modificado.importe;
    },
    importeTotalEstimado() {
      // return this.$ObjSumar(this.estimacion.conceptos, 'importe');
      return this.estimacion.conceptos.reduce((previo, { importe }) => previo + importe, 0);
    },
    importeProgramadoActual() {
      return this.mixCalcularPrograma(this.estimacion.fechaAl);
    },
    importeEstimadoActual() {
      if (this.contrato.esObraFinanciada) {
        return this.$numberRoundDigits(
          (this.estimacion.importeEstimado + this.importeEstimadoAnterior), 2,
        );
      }

      return this.$numberRoundDigits(this.importeTotalEstimado + this.importeEstimadoAnterior, 2);
    },
    importeRestanteContrato() {
      return this.importeDelContrato - this.importeEstimadoActual;
    },
    importeEstimadoAnterior() {
      return this.$ObjSumar(this.estimaciones
        .filter(({ numero }) => numero < this.estimacionEditar.numero), 'importeEstimado');
    },
    importeRetenidoAnterior() {
      return this.$ObjSumar(this.estimaciones
        .filter(({ numero }) => numero < this.estimacionEditar.numero), 'importeRetenido');
    },
    importeDevueltoAnterior() {
      return this.$ObjSumar(this.estimaciones
        .filter(({ numero }) => numero < this.estimacionEditar.numero), 'importeDevuelto');
    },
    importeAnticipoAmortizadoTotal() {
      return this.$ObjSumar(this.estimaciones
        .filter(({ numero }) => numero < this.estimacionEditar.numero), 'importeAmortizacionAnticipo');
    },
    importeTotalIvaEstimado() {
      return this.$ObjSumar(this.estimaciones, 'importeIva');
    },
    getImporteTotalAnticipoContratos() {
      if (this.contrato.esObraFinanciada) {
        return this.$ObjSumar(this.contrato.anticipos, 'importeInicioTrabajos');
      }
      return this.$ObjSumar(this.contrato.anticipos, 'importe');
    },
    getImporteTotalAnticipoContratadoFinanciado() {
      return this.$ObjSumar(this.contrato.anticipos, 'importeCostoFinanciamiento');
    },
    getImporteIvaAnticiposContrato() {
      return this.$ObjSumar(this.contrato.anticipos, 'iva');
    },
    getNumeroEstimacion() {
      return this.estimaciones.length + 1;
    },
    importeNeto() {
      return this.estimacion.importeNeto;
    },
    importeAmortizacionAnticipo() {
      return this.estimacion.importeAmortizacionAnticipo;
    },
    /**
     * Ajustes de centavos
     */
    // Estimado
    getImporteAjusteAlEstimado() {
      return this.importeDelContrato - this.importeEstimadoActual;
    },
    // Amortizado
    getImporteAjusteAlAmortizado() {
      return (
        this.getImporteTotalAnticipoContratos
        - (this.importeAnticipoAmortizadoTotal
          + this.estimacion.importeAmortizacionAnticipo)
      );
    },
    // IVA
    getImporteAjusteIva() {
      return (
        this.contrato.iva
        - (this.getImporteIvaAnticiposContrato
          + (this.importeTotalIvaEstimado + this.estimacion.importeIva))
      );
    },
    mostrarCalculos() {
      return {
        'costo-directo': {
          titulo: 'Costo directo',
          signo: '',
          monto: this.estimacion.importeCostoDirecto || 0,
        },
        'costo-indirecto': {
          titulo: `Indirectos (${this.contrato.porcentajeCostoIndirectos}%)`,
          signo: '',
          monto: this.estimacion.importeCostoIndirectos || 0,
        },
        utilidad: {
          titulo: `Utilidad (${this.contrato.porcentajeUtilidad}%)`,
          signo: '',
          monto: this.estimacion.importeUtilidad || 0,
        },
        adicionales: {
          titulo: `Adicionales (${this.contrato.porcentajeCargosAdicionales}%)`,
          signo: '',
          monto: this.estimacion.importeCargosAdicionales || 0,
        },
        estimado: {
          titulo: 'Estimado',
          signo: '',
          monto: this.estimacion.importeEstimado || 0,
        },
        'divisor-1': {
          titulo: 'divisor',
        },
        // 'estimado-neto': {
        //   titulo: 'Estimado Neto',
        //   signo: '',
        //   monto: this.estimacion.importeNeto,
        // },
        'amortizacion-anticipo': {
          titulo: 'Amortización de Anticipo',
          signo: '-',
          monto: this.estimacion.importeAmortizacionAnticipo,
        },
        'divisor-2': {
          titulo: 'divisor',
        },
        subtotal: {
          titulo: 'Subtotal',
          signo: '',
          monto: this.estimacion.subtotal,
        },
        'costo-financiamiento': {
          titulo: `Costo Financiero (${this.estimacion.porcentajeCostoFinanciero}%)`,
          signo: '+',
          monto: this.estimacion.importeCostoFinanciero || 0,
        },
        'subtotal-dos': {
          titulo: 'Subtotal 2',
          signo: '',
          monto: this.estimacion.subtotalDos || 0,
        },
        'importe-iva': {
          titulo: 'Importe I.V.A',
          signo: '',
          monto: this.estimacion.importeIva,
        },
        'divisor-3': {
          titulo: 'divisor',
        },
        'total-factura': {
          titulo: 'Total Factura',
          signo: '',
          monto: this.estimacion.totalFactura,
        },
        'divisor-5': {
          titulo: 'divisor',
        },
        deducciones: {
          titulo: 'Deducciones Contratadas',
          signo: '',
          monto: this.estimacion.importeDeducciones,
        },
        'divisor-7': {
          titulo: 'divisor',
        },
        'retencion-devolucion': {
          titulo: 'Retención o Devolución',
          signo:
            this.estimacion.importeDevuelto >= this.estimacion.importeRetenido
              ? '+'
              : '-',
          monto:
            this.estimacion.importeDevuelto + this.estimacion.importeRetenido,
        },
        sancion: {
          titulo: 'Sanción',
          signo: '-',
          monto: this.estimacion.importeSancion,
        },
        'divisor-6': {
          titulo: 'divisor',
        },
        bofificacion: {
          titulo: 'Ajuste',
          signo: '+',
          monto: this.estimacion.importeBonificacion,
        },
        'divisor-4': {
          titulo: 'divisor',
        },
        'importe-liquido': {
          titulo: 'Importe Liquido',
          signo: '',
          monto: this.estimacion.importeLiquido,
        },
      };
    },
    existeEstimacionFinPrograma() {
      return this.estimaciones
        .some(({ esEstimacionFinPrograma }) => esEstimacionFinPrograma === true);
    },
    fechaFinPrograma() {
      if (!this.existeEstimacionFinPrograma) {
        return this.programa.programaFinal.fechaTermino;
      }
      return '';
    },
  },
  watch: {
    'estimacion.fechaDel': {
      handler() {
        this.calcularEstimacion();
      },
    },
    'estimacion.fechaAl': {
      handler() {
        this.calcularEstimacion();
      },
    },
    'estimacion.esEstimacionFiniquito': {
      handler() {
        this.calcularEstimacion();
      },
    },
    'estimacion.porcentajeIva': {
      handler() {
        this.calcularEstimacion();
      },
    },
    'estimacion.porcentajeAnticipo': {
      handler() {
        this.calcularEstimacion();
      },
    },
    'estimacion.porcentajeCostoFinanciero': {
      handler() {
        this.calcularEstimacion();
      },
    },
    'estimacion.importeCostoFinanciero': {
      handler() {
        this.calcularEstimacion();
      },
    },
    amortizarAnticipo: {
      handler() {
        this.calcularEstimacion();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.altura-catalogo-conceptos {
  height: 600px !important;
  overflow: auto;
}
</style>
